import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="p-12 flex items-center justify-center min-h-[70vh]">
      <div className="max-w-md text-center">
        <XCircle className="w-16 h-16 text-zinc-500 mx-auto mb-6" strokeWidth={1.5} />
        <div className="font-mono-tech text-[10px] text-zinc-400 mb-3">PAYMENT · CANCELLED</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-3">No charge made</h1>
        <p className="text-zinc-400 mb-6">You can pick a package again whenever you&apos;re ready.</p>
        <div className="flex gap-3 justify-center">
          <Button onClick={() => nav("/pricing")} className="bg-amber-500 hover:bg-amber-600 text-black">Back to pricing</Button>
          <Button variant="ghost" onClick={() => nav("/")}>Dashboard</Button>
        </div>
      </div>
    </div>
  );
}
